
export class Videos {
    constructor() {

        this.search = null;
        this.searchTemp = null;
        this.magnfi_only = false;
    }

    activate(params) {
        this.account_owner_id = params.account_owner_id;
        this.whitelabel_id = params.whitelabel_id;

    }


    attached() {
        this.requestList.activate(null, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.submissionList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.brandVideoList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.caseStudyList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.videoEmailList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
        this.videoMessageList.activate(this.account_owner_id, this.magnfi_only ? "NONE" : this.whitelabel_id, this.search);
    }

    handleKeypress(event) {
        if (event.keyCode == 13) {
            this.search = this.searchTemp;
            this.attached();
            //event.preventDefault();
            return false;
        }

        return true;
    }

    search_user() {
        this.search = this.searchTemp;
        this.attached();
    }
}
